export default __webpack_public_path__ + "media/images/new_year/mosaic_mobile-132115708fb05f2c36a0c48d7d5eb45c.webp";